// extracted by mini-css-extract-plugin
export default {"balanceWrapper":"MyBalance__balanceWrapper--1au","balance":"MyBalance__balance--2In","balanceLow":"MyBalance__balanceLow--38Z","icon":"MyBalance__icon--136"};